export default "__VITE_ASSET__0e455dcb__"